export const authorizedCustomerProfileQuery = `
  query authorizedCustomerProfile($email: String!, $token: String!) {
    authorizedCustomerProfile(email: $email, token: $token) {
      loyalty {
        tierLabel
      }
    }
  }
`
